import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'feedback-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class FeedbackAlertComponent {
  @Input() tittle: string = '';
  @Input() message: string = '';
  @Input() show: boolean = false;
  @Input() alertType: string = 'info';
  @Output() closed = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();

  @Input() showCancel: boolean = false;
  @Input() showConfirm: boolean = false;

  constructor() {}

  close() {
    this.closed.emit();
  }

  confirm() {
    this.confirmed.emit();
  }

  get backgroundColor(): string {
    switch (this.alertType) {
      case 'success':
        return '#8DC881';
      case 'warning':
        return '#E2CA64';
      case 'error':
        return '#E29583';
      case 'info':
      default:
        return '#C0ECE8';
    }
  }

  get fontColor(): string {
    switch (this.alertType) {
      case 'success':
        return 'white';
      case 'warning':
        return '#29343d';
      case 'error':
        return 'white';
      case 'info':
      default:
        return '#29343d';
    }
  }
}
